import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { X } from 'lucide-react';
import { stripePromise } from '../lib/stripe';

interface Props {
  clientSecret: string;
  onClose: () => void;
}

/**
 * Modale de paiement Stripe Embedded Checkout — la saisie de carte se fait
 * dans une iframe Stripe directement sur la page (l'utilisateur ne quitte pas
 * Festin). Après paiement, Stripe redirige vers le `return_url` configuré côté
 * serveur (/stand/festivals?payment=pending), où le webhook confirme le statut.
 */
export function StripeCheckoutModal({ clientSecret, onClose }: Props) {
  return (
    <div
      className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-end md:items-center justify-center"
      onClick={onClose}
    >
      {/* Mobile : drawer du bas — Desktop : modale centrée */}
      <div
        className="relative w-full md:max-w-lg md:mx-4 md:rounded-2xl rounded-t-2xl bg-white shadow-2xl max-h-[92dvh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Handle mobile */}
        <div className="flex justify-center pt-3 pb-1 md:hidden">
          <div className="w-10 h-1 rounded-full bg-gray-300" />
        </div>

        {/* Bouton fermer desktop */}
        <button
          onClick={onClose}
          aria-label="Fermer"
          className="hidden md:flex absolute -top-3 -right-3 z-10 h-9 w-9 items-center justify-center rounded-full bg-white text-gray-700 shadow-lg ring-1 ring-black/10 hover:bg-gray-100"
        >
          <X className="h-5 w-5" />
        </button>

        {/* Bouton fermer mobile */}
        <button
          onClick={onClose}
          aria-label="Fermer"
          className="md:hidden absolute top-4 right-4 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-600"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="overflow-y-auto flex-1 p-3 md:p-2 rounded-t-2xl md:rounded-2xl">
          {stripePromise ? (
            <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          ) : (
            <div className="p-8 text-center text-sm text-gray-600">
              Le paiement est momentanément indisponible (configuration Stripe manquante).
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
